import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    userName: "",
    monthlyBudget: "",
    edit:false,
    categoricalBudget: {
      food: "",
      travel: "",
      entertainment: "",
      others: "",
    },
    activeFilter: "all",
  };

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
   updateUserName(state, action) {
    state.userName = action.payload;
   },
   updateMonthlyBudget(state, action) {
    state.monthlyBudget = action.payload;
   },
   updateCategoricalBudget(state, action) {
    state.categoricalBudget = { ...state.categoricalBudget, ...action.payload };
   },
   updateActiveFilter(state, action) {
    state.activeFilter = action.payload;
   },
   updateEdit(state,action){
    state.edit=action.payload;
   },
   resetAllBudget(state) {
    state.userName = "";
    state.monthlyBudget = "";
    state.categoricalBudget = {
      food: "",
      travel: "",
      entertainment: "",
      others: "",
    };
    state.edit = false; // Optionally reset the edit flag
    state.activeFilter = "all";
  },
  
  },
})

// Action creators are generated for each case reducer function
export const { updateUserName, updateMonthlyBudget, updateCategoricalBudget, updateActiveFilter, resetAllBudget, updateEdit } = userSlice.actions;

export default userSlice.reducer;
